export const FULL_WIDTH_INPUT_MAX_LENGTH = 300;
export const CC_CENTER_SECTION_INPUT_MAX_LENGTH = 140;
export const ORGANIZER_DIRECTIONS_MAX_LENGTH = 484;
